import * as R from 'ramda';

export default (prevProps, nextProps, propNamesToCompareArr) => {
  const equals = propName => R.equals(nextProps[propName], prevProps[propName]);
  return R.all(equals)(propNamesToCompareArr);
};
